import { render } from "./countdown.vue?vue&type=template&id=2be2b996&scoped=true"
import script from "./countdown.vue?vue&type=script&lang=js"
export * from "./countdown.vue?vue&type=script&lang=js"

import "./countdown.vue?vue&type=style&index=0&id=2be2b996&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2be2b996"]])

export default __exports__